"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerAppSignatureRequestGetResponseToJSON = exports.SignerAppSignatureRequestGetResponseFromJSONTyped = exports.SignerAppSignatureRequestGetResponseFromJSON = exports.instanceOfSignerAppSignatureRequestGetResponse = exports.SignerAppSignatureRequestGetResponseDefaultSignatureTypeEnum = exports.attributeTypeMapSignerAppSignatureRequestGetResponse = void 0;
var QualifiedSignatureProperties_1 = require("./QualifiedSignatureProperties");
var SigningUser_1 = require("./SigningUser");
var AllowedSignatureTypes_1 = require("./AllowedSignatureTypes");
var SignatureRequestObject_1 = require("./SignatureRequestObject");
var EsignDisclosure_1 = require("./EsignDisclosure");
exports.attributeTypeMapSignerAppSignatureRequestGetResponse = [
    {
        name: "signatureRequest",
        type: "SignatureRequestObject",
    },
    {
        name: "user",
        type: "SigningUser",
    },
    {
        name: "isEmbedded",
        type: "boolean",
    },
    {
        name: "canInsertEverywhere",
        type: "boolean",
    },
    {
        name: "allowColorSignature",
        type: "boolean",
    },
    {
        name: "defaultDateFormat",
        type: "string",
    },
    {
        name: "transmissionGuid",
        type: "string",
    },
    {
        name: "requestTitle",
        type: "string",
    },
    {
        name: "allowedSignatureTypes",
        type: "AllowedSignatureTypes",
    },
    {
        name: "defaultSignatureType",
        type: "string",
    },
    {
        name: "embeddedParentUrl",
        type: "string",
    },
    {
        name: "embeddedRedirectUrl",
        type: "string",
    },
    {
        name: "isQualifiedSignature",
        type: "boolean",
    },
    {
        name: "qualifiedSignatureProperties",
        type: "QualifiedSignatureProperties",
    },
    {
        name: "allowReassign",
        type: "boolean",
    },
    {
        name: "allowDecline",
        type: "boolean",
    },
    {
        name: "isMobileReady",
        type: "boolean",
    },
    {
        name: "isComingFromSmsDelivery",
        type: "boolean",
    },
    {
        name: "esignDisclosure",
        type: "EsignDisclosure",
    },
];
/**
 * @export
 */
exports.SignerAppSignatureRequestGetResponseDefaultSignatureTypeEnum = {
    C: "C",
    T: "T",
    U: "U",
    E: "E",
};
/**
 * Check if a given object implements the SignerAppSignatureRequestGetResponse interface.
 */
function instanceOfSignerAppSignatureRequestGetResponse(value) {
    if (!("signatureRequest" in value) || value["signatureRequest"] === undefined)
        return false;
    if (!("user" in value) || value["user"] === undefined)
        return false;
    if (!("isEmbedded" in value) || value["isEmbedded"] === undefined)
        return false;
    if (!("canInsertEverywhere" in value) ||
        value["canInsertEverywhere"] === undefined)
        return false;
    if (!("allowColorSignature" in value) ||
        value["allowColorSignature"] === undefined)
        return false;
    if (!("defaultDateFormat" in value) ||
        value["defaultDateFormat"] === undefined)
        return false;
    if (!("transmissionGuid" in value) || value["transmissionGuid"] === undefined)
        return false;
    if (!("requestTitle" in value) || value["requestTitle"] === undefined)
        return false;
    if (!("allowedSignatureTypes" in value) ||
        value["allowedSignatureTypes"] === undefined)
        return false;
    if (!("defaultSignatureType" in value) ||
        value["defaultSignatureType"] === undefined)
        return false;
    return true;
}
exports.instanceOfSignerAppSignatureRequestGetResponse = instanceOfSignerAppSignatureRequestGetResponse;
function SignerAppSignatureRequestGetResponseFromJSON(json) {
    return SignerAppSignatureRequestGetResponseFromJSONTyped(json, false);
}
exports.SignerAppSignatureRequestGetResponseFromJSON = SignerAppSignatureRequestGetResponseFromJSON;
function SignerAppSignatureRequestGetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        signatureRequest: (0, SignatureRequestObject_1.SignatureRequestObjectFromJSON)(json["signatureRequest"]),
        user: (0, SigningUser_1.SigningUserFromJSON)(json["user"]),
        isEmbedded: json["isEmbedded"],
        canInsertEverywhere: json["canInsertEverywhere"],
        allowColorSignature: json["allowColorSignature"],
        defaultDateFormat: json["defaultDateFormat"],
        transmissionGuid: json["transmissionGuid"],
        requestTitle: json["requestTitle"],
        allowedSignatureTypes: (0, AllowedSignatureTypes_1.AllowedSignatureTypesFromJSON)(json["allowedSignatureTypes"]),
        defaultSignatureType: json["defaultSignatureType"],
        embeddedParentUrl: json["embeddedParentUrl"] == null ? undefined : json["embeddedParentUrl"],
        embeddedRedirectUrl: json["embeddedRedirectUrl"] == null
            ? undefined
            : json["embeddedRedirectUrl"],
        isQualifiedSignature: json["isQualifiedSignature"] == null
            ? undefined
            : json["isQualifiedSignature"],
        qualifiedSignatureProperties: json["qualifiedSignatureProperties"] == null
            ? undefined
            : (0, QualifiedSignatureProperties_1.QualifiedSignaturePropertiesFromJSON)(json["qualifiedSignatureProperties"]),
        allowReassign: json["allowReassign"] == null ? undefined : json["allowReassign"],
        allowDecline: json["allowDecline"] == null ? undefined : json["allowDecline"],
        isMobileReady: json["isMobileReady"] == null ? undefined : json["isMobileReady"],
        isComingFromSmsDelivery: json["isComingFromSmsDelivery"] == null
            ? undefined
            : json["isComingFromSmsDelivery"],
        esignDisclosure: json["esignDisclosure"] == null
            ? undefined
            : (0, EsignDisclosure_1.EsignDisclosureFromJSON)(json["esignDisclosure"]),
    };
}
exports.SignerAppSignatureRequestGetResponseFromJSONTyped = SignerAppSignatureRequestGetResponseFromJSONTyped;
function SignerAppSignatureRequestGetResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        signatureRequest: (0, SignatureRequestObject_1.SignatureRequestObjectToJSON)(value["signatureRequest"]),
        user: (0, SigningUser_1.SigningUserToJSON)(value["user"]),
        isEmbedded: value["isEmbedded"],
        canInsertEverywhere: value["canInsertEverywhere"],
        allowColorSignature: value["allowColorSignature"],
        defaultDateFormat: value["defaultDateFormat"],
        transmissionGuid: value["transmissionGuid"],
        requestTitle: value["requestTitle"],
        allowedSignatureTypes: (0, AllowedSignatureTypes_1.AllowedSignatureTypesToJSON)(value["allowedSignatureTypes"]),
        defaultSignatureType: value["defaultSignatureType"],
        embeddedParentUrl: value["embeddedParentUrl"],
        embeddedRedirectUrl: value["embeddedRedirectUrl"],
        isQualifiedSignature: value["isQualifiedSignature"],
        qualifiedSignatureProperties: (0, QualifiedSignatureProperties_1.QualifiedSignaturePropertiesToJSON)(value["qualifiedSignatureProperties"]),
        allowReassign: value["allowReassign"],
        allowDecline: value["allowDecline"],
        isMobileReady: value["isMobileReady"],
        isComingFromSmsDelivery: value["isComingFromSmsDelivery"],
        esignDisclosure: (0, EsignDisclosure_1.EsignDisclosureToJSON)(value["esignDisclosure"]),
    };
}
exports.SignerAppSignatureRequestGetResponseToJSON = SignerAppSignatureRequestGetResponseToJSON;
